<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";
export default Vue.extend({
  name: "App",
  data: () => ({
    sessionCheckInterval: null as number | null,
  }),
  computed: {
    ...mapGetters(["isLoggedIn"]),
  },
  mounted() {
    this.checkSessionTimeout();
    this.sessionCheckInterval = window.setInterval(this.checkSessionTimeout, 10000); // Check every 10 sec
  },
  beforeDestroy() {
    if (this.sessionCheckInterval) {
      clearInterval(this.sessionCheckInterval);
    }
  },
  methods: {
    async checkSessionTimeout() {
      if(!this.isLoggedIn){
        return;
      }
      const shouldLogout = await this.$store.dispatch("CheckUserLogout");
        if (shouldLogout) {
          this.logoutUser("Your account has been Locked or Deleted by admin.");
          return;
        }
      const loginTime = localStorage.getItem("loginTime");
      // const sessionDuration = 12 * 60 * 60 * 1000; // 12 hours in milliseconds
      // const sessionDuration = 10 * 1000; // 30 seconds for testing
      const sessionDuration = 3 * 30 * 24 * 60 * 60 * 1000; // 3 months in milliseconds
      if (loginTime && Date.now() - parseInt(loginTime) > sessionDuration) {
        this.logoutUser();
      }
    },
    logoutUser(message = "Your session has expired. Please log in again.") {
      this.$store.dispatch("Logout");
      localStorage.removeItem("loginTime");
      this.$router.push("/");
      this.$swal.fire({
        position: "center",
        icon: "warning",
        title: message,
        showConfirmButton: true,
        confirmButtonColor: "#1976d2",
        allowOutsideClick: false,
        // timer: 3000,
        toast: false,
      });
    },
  },
});
</script>

<style>
.skiptranslate {
  display: none !important;
}
body {
  top: 0 !important;
}
.goog-te-banner-frame {
  display: none !important;
}
#google_translate_element {
  display: none;
}
</style>
